import { render, staticRenderFns } from "./BrandingSpecialField.vue?vue&type=template&id=00df5a7e&scoped=true&"
import script from "./BrandingSpecialField.vue?vue&type=script&lang=js&"
export * from "./BrandingSpecialField.vue?vue&type=script&lang=js&"
import style0 from "./BrandingSpecialField.vue?vue&type=style&index=0&id=00df5a7e&lang=scss&scoped=true&"
import style1 from "./BrandingSpecialField.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00df5a7e",
  null
  
)

export default component.exports